function getBaseUrl(path) {
  var pathArray = path.split( '/' );
  var protocol = pathArray[0];
  var host = pathArray[2];
  var url = protocol + '//' + host;
  return url;
}

function isIframe(obj) {
	return obj && obj.tagName && (obj.tagName.toLowerCase() === 'iframe');
}

function isSwMessage(e) {
	return e.data.pairID && e.data.swData && e.data.action;
}

function uniqueId() {
  return Date.now() + uniqueId.uID() + '-' + uniqueId.uID() + '-' + uniqueId.uID() + '-'+ uniqueId.uID();
}

uniqueId.uID = function uID() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

module.exports = {
	getBaseUrl: getBaseUrl,
	isIframe: isIframe,
	isSwMessage: isSwMessage,
	uniqueId: uniqueId
};